import axios, { InternalAxiosRequestConfig, AxiosRequestHeaders } from 'axios';

// Utility function to get client validation headers
const getClientValidationHeaders = () => {
  if (typeof window === 'undefined') return {};

  const groupHash = document.querySelector('meta[name="x-group-hash"]')?.getAttribute('content');
  let groupHost = new URL(window.location.href).host;

  // For dev environment, use VITE_APP_DOMAIN_DEV if host contains localhost
  if (groupHost.includes('localhost')) {
    groupHost = import.meta.env.VITE_APP_DOMAIN_DEV || groupHost;
  }

  return {
    ...(groupHash && { 'x-group-hash': groupHash }),
    ...(groupHost && { 'x-group-host': groupHost }),
  };
};

export const api = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL as string,
  paramsSerializer: (params: Record<string, string | number | boolean | (string | number | boolean)[]>) => {
    const result = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (Array.isArray(value)) {
        // Serialize arrays without brackets
        value.forEach((item) => result.append(key, String(item)));
      } else {
        result.append(key, String(value));
      }
    }
    return result.toString();
  },
});

api.interceptors.request.use((config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  // Attach JWT token from localStorage if available
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  // Get client validation headers
  const clientHeaders = getClientValidationHeaders();

  // Initialize headers if undefined to avoid type error
  config.headers = {
    ...config.headers,
    ...clientHeaders,
    ...(token && { Authorization: `Bearer ${token}` }),
  } as AxiosRequestHeaders;

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // If the response is 401 Unauthorized, optionally log the user out
    if (error.response && error.response.status === 401) {
      if (typeof window !== 'undefined') {
        localStorage.removeItem('token');
        // Optionally, you can redirect to login page or emit an event here
      }
    }
    return Promise.reject(error);
  }
);
